"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function FormPublish(_a) {
    var livestream = _a.livestream, setLivestream = _a.setLivestream;
    function publish(publish) {
        setLivestream({ publish: publish });
        if (livestream.id) {
            ra_fetch_1.Fetcher.api('backend').update('livestreams', {
                id: livestream.id,
                publish: publish,
                channel_id: livestream.channel_id
            });
        }
    }
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'storybook-videos-form-status' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("div", { className: 'storybook-videos-form-status-title' },
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, "Publiceren wijzigen"),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(storybook_1.Texts.Span, { className: 'storybook-forms-status-label' }, "Publiceren"),
                    react_1.default.createElement(storybook_1.Forms.Toggle, { value: livestream.publish, onClick: function () { return publish(!livestream.publish); } }))),
            react_1.default.createElement(storybook_1.Texts.Small, { className: "mt-4" }, "Publiceer de live opname na afloop automatisch als VOD.")));
}
exports.default = FormPublish;
FormPublish.propTypes = {
    livestream: prop_types_1.default.object.isRequired,
    setLivestream: prop_types_1.default.func.isRequired,
};
